"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../helpers");
var _Forms = require("./Forms");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const JoinUpdate = props => {
  const {
    // name,
    schema,
    value,
    fetching,
    edit
  } = props;
  if (edit) return /*#__PURE__*/_react.default.createElement(_Forms.JoinUpdate, props);
  if (fetching) return /*#__PURE__*/_react.default.createElement("span", {
    className: "component-string-placeholder" + (fetching ? " fetching" : ""),
    style: {
      width: `${(0, _helpers.getRandomInt)(4, 8)}em`
    }
  });
  if (!value || !value.length) return /*#__PURE__*/_react.default.createElement("span", {
    className: "component-string-placeholder",
    style: {
      width: `${(0, _helpers.getRandomInt)(4, 8)}em`
    }
  });
  return value.map(val => {
    if (typeof schema.entities.displayName === "function") return schema.entities.displayName(val);
    return /*#__PURE__*/_react.default.createElement("span", {
      className: "badge badge-pill badge-primary mr-2",
      key: val.Id
    }, val[schema.entities.foreign] ? val[schema.entities.foreign][schema.entities.displayName] || val[schema.entities.foreign].Id : null);
  });
};
var _default = exports.default = JoinUpdate;
module.exports = exports.default;